export const WarningTriangleIcon = ({
  stroke = "white",
  size = 18,
  strokeWidth = 1.5,
}: {
  stroke?: string;
  size?: number;
  strokeWidth?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M8.02606 5.10929V8.02306M8.02606 10.9368H8.03335M15.1138 11.6653L9.28626 1.46708C9.1592 1.24287 8.97493 1.05638 8.75226 0.926627C8.52959 0.796877 8.27649 0.728516 8.01877 0.728516C7.76106 0.728516 7.50796 0.796877 7.28529 0.926627C7.06262 1.05638 6.87835 1.24287 6.75128 1.46708L0.923736 11.6653C0.795298 11.8877 0.72795 12.1402 0.728519 12.397C0.729088 12.6539 0.797553 12.906 0.926974 13.1279C1.0564 13.3497 1.24217 13.5334 1.46548 13.6604C1.68878 13.7873 1.94167 13.8529 2.19851 13.8506H13.8536C14.1092 13.8504 14.3603 13.7828 14.5815 13.6549C14.8028 13.5269 14.9865 13.343 15.1142 13.1215C15.2419 12.9001 15.3091 12.649 15.309 12.3934C15.3089 12.1377 15.2416 11.8867 15.1138 11.6653Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
